module.exports = __webpack_public_path__ + "img/icon-processing-alt-audio.d07397fc.svg";